import { render, staticRenderFns } from "./RecipientListItem.vue?vue&type=template&id=57a94b0c&scoped=true"
import script from "./RecipientListItem.vue?vue&type=script&lang=js"
export * from "./RecipientListItem.vue?vue&type=script&lang=js"
import style0 from "./RecipientListItem.vue?vue&type=style&index=0&id=57a94b0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a94b0c",
  null
  
)

export default component.exports